const MAX_AGE = {
  news: 1000 * 60, // 1 minute
  matches: 1000 * 30, // 30 seconds
  groups: 1000 * 60 * 30, // 30 minutes
  schedule: 1000 * 60 * 2, // 2 minutes
  clipsAndPlaylists: 1000 * 30 // seconds
}

export { MAX_AGE }
